import {
	MimaText,
	Modal,
	ReceiptCheckBox as RCB,
	FlexButton,
	MimaButton,
} from '../../components';
import styles from '../../assets/styles/BusinessAdmin/BusinessAdmin.module.scss';
import { PermissionListContainer } from '../../containers';
import React from 'react';

const AddBusinessAdmin = ({
	closeModal,
	permissions,
	showGroupPermissions,
	employeeData,
	availablePermissions,
	groupPermissions,
	showPermissions,
}) => {
	return (
		<Modal closeModal={closeModal}>
			{!groupPermissions && (
				<>
					<MimaText variant="subtitleBold" mb={2}>
						Add Business Admin
					</MimaText>
					<MimaText mb={2}>Select Employee</MimaText>
					<table className={styles.table}>
						<tbody>
							{employeeData.map((employee, i) => (
								<tr key={i} onClick={()=> {
									showGroupPermissions(employee)
								}}>
									<td>{`${employee.user.firstname} ${employee.user.lastname}`} </td>
									<td>{employee.jobTitle} </td>
								</tr>
							))}
						</tbody>
					</table>
				</>
			)}

			{groupPermissions && <PermissionListContainer closeModal={closeModal} />}
		</Modal>
	);
};

export default AddBusinessAdmin;
